import { createApp } from 'vue'
import SignUpForm from './SignUpForm'

const el = '.kb-component--sign-up-form'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SignUpFormDOM) => {
            const component = createApp(SignUpForm).use(Store)
            component.mount(SignUpFormDOM)
        })
    }
}
